import { action, makeObservable } from 'mobx';
import { getRegister } from '../api/admin';

class RegisterStore {
  constructor() {
    makeObservable(this, {
      getByCompanyKey: action,
    });
  }

  async getByCompanyKey(companyKey: string): Promise<string | undefined> {
    const res = await getRegister(companyKey);

    if (res) {
      return JSON.stringify(res, null, 2);
    }
    return undefined;
  }
}

export default RegisterStore;
